import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@/environments/environment";
import { Province } from "../interface/province.interface";
import { DeliveryAddressModel } from "../interface/user.interface";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AddressService {

  constructor(private http: HttpClient) {}

  deleteUserAddress(id: number) {
    return this.http.delete<any>(`${environment.baseURL}user/province`);
  }

  updateUserAddress(address: any) {
    return this.http.put<any>(`${environment.baseURL}user/user/address`, address,
    { headers: { 'Content-Type': 'application/json' } } );
  }

  getUserAddress() {
    return this.http.get<DeliveryAddressModel>(`${environment.baseURL}user/user/address`);
  }
  getChildUserAddress(): Observable<DeliveryAddressModel[]> {
    return this.http.get<DeliveryAddressModel[]>(`${environment.baseURL}user/user/children-address`);
  }

  createUserAddress(address: any) {
    return this.http.post<any>(`${environment.baseURL}user/user/address`, address,
    { headers: { 'Content-Type': 'application/json' } }
    );

  }

  checkInvoiceAddressReviewed() {
    return this.http.get<boolean>(`${environment.baseURL}user/useraddress/v1/check-invoice-address-reviewed`);
  }
}
